import { combineReducers } from "redux";
import propertyDocumentsReducer from "./propertyDocumentsReducer";

const propertyDocsReducer = combineReducers({
    propertyDocuments: propertyDocumentsReducer

});

export default propertyDocsReducer;